import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
const vuexLocal = new VuexPersistence({
    storage: window.localStorage
})


Vue.use(Vuex)
const store = new Vuex.Store({
    // 开启严格模式，任何对状态的更改如果不是通过mutation操作引起的，将会报警告
    strict: true,
    state: {
        studentBar: [
            {
                id: '1',
                label: '我的课程',
                route: '/taskClass',
                icon: 'golf',
                icon_active: 'golfActive'
            },
            {
                id: '2',
                label: '我的评价',
                route: '/myEvaluate',
                icon: 'library',
                icon_active: 'libraryActive'
            },
            {
                id: '3',
                label: '我的数据',
                route: '/myData',
                icon: 'evaluate',
                icon_active: 'evaluateActive'
            },
            {
                id: '4',
                label: '我的信息',
                route: '/studentMyInfo',
                icon: 'myIcon',
                icon_active: 'myIconActive'
            }
        ],
        coachBar: [
            {
                id: '1',
                label: '每日训练',
                route: '/everyTrain',
                icon: 'golf',
                icon_active: 'golfActive'
            },
            {
                id: '2',
                label: '学员任务',
                route: '/studentTaskWarp',
                icon: 'library',
                icon_active: 'libraryActive'
            },
            {
                id: '3',
                label: '学员评价',
                route: '/studentEvaluateWarp',
                icon: 'evaluate',
                icon_active: 'evaluateActive'
            },
            {
                id: '4',
                label: '我的信息',
                route: '/coachMyInfo',
                icon: 'myIcon',
                icon_active: 'myIconActive'
            }
        ],
        token: '',
        userInfo: {},
        addTaskActived: {},
        syncTask: 0,
        readMessage: 0,

    },

    getters: {
        // doubleCount: (state) => state.count * 2
    },

    mutations: {
        CHANGE_COUNT(state, val) {
            state.readMessage = val
        },
        SET_TOKEN(state, val) {
            state.token = val
        },
        SET_USERINFO(state, val) {
            state.userInfo = val
        },
        SET_TaskActived(state, val) {
            state.addTaskActived = val
        },
        SET_SYNC_TASK(state, val) {
             state.syncTask = val
        }
    },
    actions: {
        setCount({ commit }, data) {
            if (data.type === '+') {
                commit('INCREASE_COUNT', data.value)
            } else {
                commit('DECREASE_COUNT', data.value)
            }
        }
    },
    plugins: [vuexLocal.plugin]
})

export default store
